import type { DecoratedAggregatedOrderView } from '@/types/api/aggregated/order'
import type { UserBase } from '@/types/api/roles'

import { UNASSIGNED_TRADER_ID } from '@/trading/hooks/use-get-trader-options'
import { OrderMetadataFields } from '@/types/enums/order'
import { PLACEHOLDER } from '@/utils/presentation/formatting'

import { getHumanReadableUserIdentifierById } from './get-human-readable-user-identifier-by-id'

/**
 * Fetches the trader ID from the order metadata and then uses that ID to look up a human-readable identifier.
 * @param order - The order to get the trader identifier for.
 * @param usersData - The users data to get the trader identifier from.
 * @returns A human-readable trader identifier (name, email, or ID).
 */
function getHumanReadableTraderIdentifier(
  order: DecoratedAggregatedOrderView | null,
  usersData: Record<string, Partial<UserBase>> | undefined,
): string {
  const traderId = order?.metadata?.[OrderMetadataFields.TraderId] as
    | string
    | undefined

  if (!traderId || traderId === UNASSIGNED_TRADER_ID) {
    return PLACEHOLDER
  }
  if (!usersData) {
    return traderId
  }

  return getHumanReadableUserIdentifierById(traderId, usersData)
}

// biome-ignore lint/style/noDefaultExport: Existing default export — prefer named exports for new code
export default getHumanReadableTraderIdentifier
